/* Copyright (c) 2026. Amazon.com, Inc. or its affiliates. All rights reserved. */

/**
 * Resolve after `seconds` have elapsed. Unit is SECONDS (the codebase
 * standard for latency values); the timer is fed ms internally.
 */
export function sleep(seconds: number): Promise<void> {
    return new Promise((resolve) => setTimeout(resolve, seconds * 1000))
}
